export function isDublinId(id: string) {
  return (
    id === "d30b9a46-7986-4a7a-a4c1-5453b204180b" || // production
    id === "8a312c31-dc01-4803-9bb6-77da889b7a76" // Henry's
  )
}
